import { toDataURL } from 'qrcode';
import {
  SUBPATH_PREFIX,
  currentSubpathEventLabel,
  loadedEventIdentifier,
  publicEventPathId,
} from 'src/app/@utils/base-path';

/**
 * Address the event QR opens, on the host serving this page.
 * Under /event: {origin}/event/{stored event id}. On an event subdomain: the site root.
 */
export function eventQrTargetUrl(
  loc: Pick<Location, 'origin' | 'pathname' | 'search'>,
  storedId: string | null = loadedEventIdentifier()
): string {
  const id = publicEventPathId(loc, storedId);
  if (id) return `${loc.origin}${SUBPATH_PREFIX}/${encodeURIComponent(id)}`;
  const label = currentSubpathEventLabel(loc);
  return label
    ? `${loc.origin}${SUBPATH_PREFIX}/?event=${encodeURIComponent(label)}`
    : `${loc.origin}/`;
}

/** The uploaded EventQR image, or a generated QR (data URL) when none is set. */
export async function resolveEventQr(
  uploaded: string | null | undefined,
  target: string
): Promise<string> {
  if (uploaded?.trim()) return uploaded;
  return toDataURL(target, { margin: 1, width: 512 });
}
